var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "feature-card" }, on: { click: _vm.gotoPlans } },
    [
      !_vm.currentPlan
        ? _c(
            "div",
            { staticClass: "water-mark" },
            [
              _c("SupsisButton", { attrs: { primary: true } }, [
                _vm._v(" Satın Al"),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "feature-logo" }, [_c("ExtraPlanIcon")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "feature-content" }, [
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.plan.altTitle) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _vm.currentPlan
            ? _c("div", [
                _vm.detailPackage().renewed
                  ? _c("div", [
                      _c("b", [_vm._v("Yenilenme Tarihi:")]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.detailPackage().endDate))]),
                    ])
                  : _c("div", [
                      _c("b", [_vm._v("Kalan Süre:")]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(_vm.detailPackage().leftTime) + " gün"),
                      ]),
                    ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }